import { VCard, VTextField, VCardSubtitle, VCheckbox, VRow, VCardText } from 'vuetify/lib'

export default {
    data() {
        return {
            materials: {
                selected_list: [],
                input_hash: {}
            }
        }
    },
    computed: {
        materialsList() {
            return this.$store.getters['async/opening_shop_materials'] || []
        },
    },
    watch: {
        materialsList(val) {
            this.initMaterial(val)
        }
    },
    mounted() {
        this.initMaterial(this.materialsList)
    },
    methods: {
        initMaterial(val) {
            (val || []).forEach(item => {
                item.labels && item.labels.forEach(label => {
                    if (this.materials.input_hash[item.id + '/' + label] === undefined) {
                        this.$set(this.materials.input_hash, item.id + '/' + label, '')
                    }
                })
            })
        },
        init(materials) {
            if (!materials || !materials.length) {
               return
            }
            materials.forEach(material => {
                this.materials.selected_list.push(material.id)
                material.labels && material.labels.forEach((label, index) => {
                    this.materials.input_hash[`${material.id}/${label}`] = material.values[index]
                })
            })
        },
        clear() {
            this.materials.selected_list = []
            Object.keys(this.materials.input_hash || {}).forEach(key => {
                this.materials.input_hash[key] = null
            })
        },
        getData() {
            return this.materials
        }
    },
    render() {
        const _this = this
        return <div>
            <VCard flat outlined>
                <VCardSubtitle>
                    所需资质证书
                </VCardSubtitle>
                <VCardText>
                {_this.materialsList.map(item => {
                    return <VRow 
                            align="center"
                            class={item.labels && "mt-3"}
                        >
                                    <VCheckbox
                                        class={['shrink', 'mr-2', !item.labels ? 'mt-5' : 'mt-0'].join(' ')}
                                        hide-details
                                        v-model={_this.materials.selected_list}
                                        label={item.material_name}
                                        value={item.id}
                                    />              
                                     { item.labels && item.labels.map(label => {
                                                return <VTextField
                                                            v-model={_this.materials.input_hash[item.id + '/' + label]}
                                                            style={{
                                                               margin: '0 10px'
                                                               // width: '15%'
                                                            }}
                                                            label={label}
                                                        />
                                                   
                                            })
                        
                        
                               }              
                           
                        </VRow>
                })}
                </VCardText>
                
            </VCard>
        </div>
    }
}